export enum PropertyOccupationOpposition {
  IN_WRITING = 'POR_ESCRITO',
  JUDICIALLY = 'JUDICIALMENTE',
  VERBALLY = 'VERBALMENTE',
  OTHER = 'OUTRO',
}
